import EmpleadoService from "@/api/services/personal/empleado/EmpleadoService"
import Vue from "vue"

const state = () => ({
    empleados: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "codigo",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    EMPLEADOS: state => {
        return state.empleados
    },
    EMPLEADOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_EMPLEADOS: (state, payload) => {
        state.empleados = payload
    },

    SET_EMPLEADOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_EMPLEADO: (state, payload) => {
        state.empleados.push(payload)
    },

    UPDATE_EMPLEADO: (state, payload) => {
        state.empleados = state.empleados.map(el => (el.id === payload.id ? payload : el))
    }
}

const actions = {
    LOAD_EMPLEADOS: async ({ commit, state }, { filter, empleadoEstado, customfilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await EmpleadoService.get({
                filter,
                empleadoEstado,
                customfilter,
                ...pagination
            })
            if (status === 200) {
                commit("SET_EMPLEADOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los empleados, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_EMPLEADOS: async ({ commit }) => {
        try {
            let { data, status } = await EmpleadoService.getAll()
            if (status === 200) {
                commit("SET_EMPLEADOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_EMPLEADOS: async ({ commit }) => {
        try {
            let { data, status } = await EmpleadoService.getAllRecords()
            if (status === 200) {
                commit("SET_EMPLEADOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los empleados, inténtelo nuevamente"
            })
        }
    },

    LOAD_EMPLEADO_DETAILS: async ({ commit }, payload) => {
        try {
            let { data, status } = await EmpleadoService.loadDetails(payload)
            if (status === 200) {
                commit("UPDATE_EMPLEADO", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las solicitudes, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_EMPLEADO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EmpleadoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_EMPLEADO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del empleado, inténtelo nuevamente"
            })
        }
    },

    ADD_EMPLEADO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EmpleadoService.post(payload)
            if (status === 201) {
                commit("ADD_EMPLEADO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El empleado ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el empleado, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_EMPLEADO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EmpleadoService.put(payload)
            if (status === 200) {
                commit("UPDATE_EMPLEADO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El empleado ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el empleado, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    TOGGLE_STATUS_EMPLEADO: async ({ commit }, payload) => {
        try {
            if (payload.recontratacion === 1) {
                delete payload.recontratacion
                let { status, data } = await EmpleadoService.darBaja(payload)
                if (status === 204) {
                    commit("UPDATE_EMPLEADO", data)
                    Vue.notify({
                        group: "pages",
                        type: "success",
                        title: "Modificando",
                        text: "El contratato del empleado ha sido terminado satisfactoriamente"
                    })
                    return null;
                }
            } else if (payload.recontratacion === 2) {

                let { data, status } = await EmpleadoService.recontratar(payload)
                if (status === 204) {
                    commit("UPDATE_EMPLEADO", data)
                    Vue.notify({
                        group: "pages",
                        type: "success",
                        title: "Modificando",
                        text: "El contratato del empleado ha sido renovado satisfactoriamente"
                    })
                }
            }
        } catch (error) {
            if (!error.response){
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el contrato del empleado, inténtelo nuevamente"
                })
            }else {
                return { data: error.response.data, status: error.response.status }
            }

        }
    },

    APROBE_EMPLEADO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EmpleadoService.aprobar(payload)
            if (status === 200) {
                commit("UPDATE_EMPLEADO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El empleado ha sido aprobado"
                })
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido aprobar el empleado, inténtelo nuevamente"
            })
        }
    },

    REJECT_EMPLEADO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EmpleadoService.rechazar(payload)
            if (status === 200) {
                commit("UPDATE_EMPLEADO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El empleado ha sido rechazado"
                })
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido rechazar el empleado, inténtelo nuevamente"
            })
        }
    },

    LOAD_ASISTENCIA_TOTALES_EMPLEADO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EmpleadoService.loadAsistenciaTotales(payload)
            if (status === 200) {
                commit("UPDATE_EMPLEADO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los totales de la asistencia para el empleado, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
